export const canvasStyle = {
    MozTransform: 'scale(-1, 1)',
    WebkitTransform: 'scale(-1, 1)',
    OTransform: 'scale(-1, 1)',
    transform: 'scale(-1, 1)'
  }
  
export const height = 500;
export const width = 600;